import { render, staticRenderFns } from "./SelectCarousel.vue?vue&type=template&id=1566af0d&scoped=true"
import script from "./SelectCarousel.vue?vue&type=script&lang=js"
export * from "./SelectCarousel.vue?vue&type=script&lang=js"
import style0 from "./SelectCarousel.vue?vue&type=style&index=0&id=1566af0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1566af0d",
  null
  
)

export default component.exports